/** Eszközfelismerés: telefon/tablet (érintés) és mobil-specifikus módkorlátozások. */

export const TOUCH_OFF_KEY = 'csf.touch.off';

const params = (): URLSearchParams => {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
};

const media = (query: string): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia(query).matches;
  } catch {
    return false;
  }
};

/**
 * Van-e érintőképernyő (vagy kézzel kényszerítve a ?touch=1).
 *
 * Nem elég a `maxTouchPoints`: egy touchscreen notebookon egérrel is >0 lehet,
 * ilyenkor viszont a billentyűzetet/gamepadot kell használni. Ezért csak akkor
 * touch, ha a fő mutatóeszköz durva (coarse), vagy nincs hover (telefon/tablet).
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  const q = params();
  if (q.get('touch') === '1') return true;
  if (q.get('touch') === '0') return false;
  const coarse = media('(pointer: coarse)');
  const noHover = media('(hover: none)');
  const points = navigator.maxTouchPoints ?? 0;
  return coarse || (points > 0 && noHover);
};

/**
 * Mobil (telefon/tablet) eszköz. Nem a képernyőméret dönt: egy 1366×768-as
 * touchscreen notebook egérrel még asztali. A coop tiltásához ezt használjuk.
 */
export const isMobileDevice = (): boolean => {
  if (!isTouchDevice()) return false;
  const q = params();
  if (q.get('mobile') === '1') return true;
  if (q.get('mobile') === '0') return false;
  // ha a játékos kikapcsolta a touch vezérlést (pl. gamepad), asztalinak vesszük
  try {
    if (window.localStorage.getItem(TOUCH_OFF_KEY) === '1') return false;
  } catch {
    /* privát mód */
  }
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const mobileUa = /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua);
  return mobileUa || media('(hover: none)');
};

/** Fekvő tájolás ajánlott a versenyhez. */
export const isPortrait = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerHeight > window.innerWidth;
};
